import { service } from ".";

export default {
  getAll: () => service.get("/ourcustomers"),
  getOne: (id) => service.get(`/ourcustomers/${id}`),
  getAllPaginate: (query) => service.get(`/ourcustomers/paginate?${query}`),
  create: (data) => service.post("/ourcustomers", data),
  update: (id, data) => service.put(`/ourcustomers/${id}`, data),
  delete: (id) => service.delete(`/ourcustomers/${id}`),
};
